import { render, staticRenderFns } from "./WebBookings.vue?vue&type=template&id=56d815c8&"
import script from "./WebBookings.vue?vue&type=script&lang=js&"
export * from "./WebBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports